<template>
  <v-app id="app" ref="topas" style="background-color: #FAFAFA">
    <v-btn
      color="red darken-4"
      dark
      fixed
      bottom
      left
      fab
      small
      @click="$router.go(-1)"
      v-if="buttomBack"
      data-cy="btnClickBack"
    >
      <v-icon class="caption">arrow_back_ios</v-icon>
    </v-btn>
    <v-btn color="red darken-4" dark fixed bottom fab right small @click="up" v-if="!muestroOpciones">
      <v-icon>keyboard_arrow_up</v-icon>
    </v-btn>
    <v-speed-dial v-model="fab" fixed bottom right v-if="muestroOpciones">
      <template v-slot:activator>
        <v-btn v-model="fab" color="red darken-4" dark fab small>
          <v-icon>add</v-icon>
          <v-icon>close</v-icon>
        </v-btn>
      </template>
      <v-btn fab dark small color="red darken-4" @click="setLatBus()">
        <v-icon>search</v-icon>
      </v-btn>
      <v-btn fab dark small color="red darken-4" @click="up">
        <v-icon>keyboard_arrow_up</v-icon>
      </v-btn>
    </v-speed-dial>
    <TopNavBar v-if="visibleNavb" class="mb-3" />
    <v-container fluid id="view-content" class="py-0">
      <AppsNavBar />
      <keep-alive
        include="resultadoPases,resultadoHoteles,resultadoHotelesCupo,adicionalesHoteleria,pasajerosCupoAgencias"
      >
        <router-view />
      </keep-alive>
      <Footer class="mt-80" v-if="visibleFooter" />
    </v-container>
    <ModalCarrito></ModalCarrito>
    <BuscadorLateral></BuscadorLateral>
  </v-app>
</template>
<script>
import TopNavBar from "@/components/utiles/TopNavBar.vue"
import Footer from "@/components/utiles/Footer.vue"
import { mapGetters } from "vuex"
import ModalCarrito from "@/components/utiles/ModalCarrito.vue"
import AppsNavBar from "@/components/utiles/AppsNavBar.vue"
import BuscadorLateral from "@/components/utiles/BuscadorLateral.vue"
export default {
  mounted() {},
  methods: {
    up() {
      window.scrollTo(0, 0)
    },
    visibleButtomBack(valor) {
      this.buttomBack = valor
    },
    setLatBus() {
      this.$store.dispatch("app/setLatBus", true)
    },
    mostrarOpciones(ruta) {
      this.muestroOpciones = false
      if (ruta === "resultadoHoteles" && this.$vuetify.breakpoint.smAndDown) {
        this.muestroOpciones = true
      }
    }
  },
  components: {
    TopNavBar,
    Footer,
    ModalCarrito,
    AppsNavBar,
    BuscadorLateral
  },
  computed: {
    ...mapGetters("app", {
      appData: "getApp"
    }),
    visibleFooter: function() {
      if (!this.appData) {
        return false
      }
      return this.appData.footer
    },
    visibleNavb: function() {
      if (!this.appData) {
        return false
      }
      return this.appData.navbar
    }
  },
  data() {
    return {
      includes: [],
      buttomBack: false,
      drawer: false,
      fab: false,
      muestroOpciones: false
    }
  },
  watch: {
    $route(to) {
      this.visibleButtomBack(to.meta.clickback)
      this.mostrarOpciones(to.name)
    }
  }
}
</script>
<style scoped>
.mt-80 {
  margin-top: 80px;
}
</style>
